import api from 'api';
import { useQuery } from 'react-query';
import { AppError } from 'utils/AppError';
import { SalaryStructure, SalaryStructureStatus } from 'components/SalaryStructure/types';

type UseListSalaryStructuresProps = {
  enabled?: boolean;
  onSuccess?: (data: SalaryStructure[]) => void;
  filters?: SalaryStructureStatus;
  queryKey?: string[];
  select?: (data: SalaryStructure[]) => SalaryStructure[];
};

const useListSalaryStructures = ({
  enabled,
  onSuccess,
  filters,
  queryKey,
  select,
}: UseListSalaryStructuresProps) => {
  const query = useQuery({
    queryKey: queryKey,
    enabled,
    queryFn: async () => {
      const result = await api.salaryStructures.queries.listSalaryStructures({
        input: {
          status: filters || 'SALARY_STRUCTURE_STATUS_NONE',
        },
      });
      const salaryStructures = result.payrollListSalaryStructures.data.salaryStructures;
      let salaryStructureWithDefaultAtFirst: SalaryStructure[] = [];

      salaryStructures?.forEach((salaryStructure) => {
        if (salaryStructure.type === 'SALARY_STRUCTURE_TYPE_DEFAULT')
          salaryStructureWithDefaultAtFirst.unshift(salaryStructure);
        else salaryStructureWithDefaultAtFirst.push(salaryStructure);
      });
      return salaryStructureWithDefaultAtFirst;
    },
    onSuccess: (data) => onSuccess?.(data),
    onError: (error: AppError) => {
      console.log('error fetching salary structure list', error);
    },
    select,
  });

  return query;
};

export default useListSalaryStructures;
